// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".businessDailyReport[data-v-9b5cc2c2] {\n  background-color: #F2F1FF;\n}\n.businessDailyReport .banner-img1[data-v-9b5cc2c2] {\n    width: 100%;\n}\n.businessDailyReport .banner-img2[data-v-9b5cc2c2] {\n    margin-bottom: 13.9%;\n}\n.businessDailyReport .fixed-btn[data-v-9b5cc2c2] {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
